var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCascadeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1717_5084)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 9,
  width: 20,
  height: 2,
  fill: "#366CD9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 13,
  width: 20,
  height: 2,
  fill: "#366CD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2L16.3301 5.75H7.66987L12 2Z",
  fill: "#366CD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22L7.66987 18.25L16.3301 18.25L12 22Z",
  fill: "#366CD9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 5,
  width: 2,
  height: 14,
  fill: "#366CD9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1717_5084"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCascadeIcon);
export default ForwardRef;